export const clientIds = {
  nwPredictorClientId: 'nw_predictor',
  abroadDostClientId: 'abroad_dost',
  otgFormsClientId: 'otg_forms'
};
